export const PACKAGE_NAME = 'jiraSpaAppsDevopsFireTargetingEvents';
export const ID = 'devopsFireTargetingEvents';
